import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    // Initialize Meta Pixel
    const initPixel = () => {
      if (window.fbq) return // Already initialized

      const n = (window.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      }) as any

      if (!window._fbq) window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      // Load the Facebook Pixel script
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)

      // Initialize with Pixel ID and track PageView
      window.fbq('init', pixelId)
      window.fbq('track', 'PageView')
    }

    initPixel()

    // Add noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    return () => {
      // Cleanup noscript on unmount
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript)
      }
    }
  }, [pixelId])
}
